import axios from "axios";
import { getXRFHeaderValue } from "../utils/getXRFHeaderValue";
import AbstractSitesService from "./AbstractSitesService";

const sitesSettingContainerItemId = "{DFC8ACF5-380E-47A8-AC76-7BD697E5A957}";
        
class SitesService extends AbstractSitesService {
  getOptions() {
    return {
      headers: {
        "content-type": "application/json",
        "X-RequestVerificationToken": getXRFHeaderValue(),
        "X-Requested-With": "XMLHttpRequest"
      },
      withCredentials: true
    };
  }

  getSites() {
    const uri = `/sitecore/api/ssc/item/${sitesSettingContainerItemId}/children?sc_content=master`;
    return axios
      .get(uri, this.getOptions())
      .then(res => this.processSitesResponse(res.data))
      .catch(err => {
        console.error(err);
        return this.defaultSites;
      });
  }
}

export default new SitesService();



// WEBPACK FOOTER //
// ./src/data/SitesService.prod.js